import logger from '@/utils/logger'

// Função para testar todos os endpoints da Evolution API
// Execute no console do navegador: testEvolutionEndpoints()

export async function testEvolutionEndpoints() {
  const baseUrl = import.meta.env.VITE_EVOLUTION_V2_URL as string
  const apiKey = import.meta.env.VITE_EVOLUTION_V2_APIKEY as string
  const instanceName = 'Jorge Vr Tech'
  
  const endpoints = [
    `/chat/findMessages/${instanceName}`,
    `/message/findMessages/${instanceName}`,
    `/chat/find/${instanceName}`,
    `/message/find/${instanceName}`,
    `/chat/messages/${instanceName}`,
    `/message/messages/${instanceName}`,
    `/chat/getAllMessages/${instanceName}`,
    `/message/getAllMessages/${instanceName}`,
    `/chat/getMessages/${instanceName}`,
    `/message/getMessages/${instanceName}`
  ]

  const testData = { limit: 5 }
  
  logger.debug('🧪 [Test] Iniciando teste de endpoints da Evolution API...')
  
  for (const endpoint of endpoints) {
    try {
      logger.debug(`🔍 [Test] Testando: POST ${baseUrl}${endpoint}`)
      
      const response = await fetch(`${baseUrl}${endpoint}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'apikey': apiKey
        },
        body: JSON.stringify(testData)
      })

      if (response.ok) {
        const data = await response.json()
        logger.debug(`✅ [Test] SUCESSO em ${endpoint}:`, data)
        return { endpoint, data } // Retorna o primeiro que funcionar
      } else {
        logger.debug(`❌ [Test] FALHOU ${endpoint}: ${response.status} ${response.statusText}`)
      }
    } catch (err: unknown) {
      logger.debug(`❌ [Test] ERRO ${endpoint}:`, err)
    }
  }

  logger.debug('😞 [Test] Nenhum endpoint funcionou. Testando GETs...')
  
  // Testar também GETs
  const getEndpoints = [
    `/chat/messages/${instanceName}`,
    `/message/messages/${instanceName}`,
    `/chat/getAllMessages/${instanceName}`,
    `/message/getAllMessages/${instanceName}`
  ]
  
  for (const endpoint of getEndpoints) {
    try {
      logger.debug(`🔍 [Test] Testando: GET ${baseUrl}${endpoint}`)
      
      const response = await fetch(`${baseUrl}${endpoint}?limit=5`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'apikey': apiKey
        }
      })

      if (response.ok) {
        const data = await response.json()
        logger.debug(`✅ [Test] SUCESSO em ${endpoint}:`, data)
        return { endpoint, data, method: 'GET' }
      } else {
        logger.debug(`❌ [Test] FALHOU ${endpoint}: ${response.status} ${response.statusText}`)
      }
    } catch (err: unknown) {
      logger.debug(`❌ [Test] ERRO ${endpoint}:`, err)
    }
  }

  logger.debug('💀 [Test] Todos os endpoints falharam!')
  return null
}

// Exportar para o window para uso no console
if (typeof window !== 'undefined') {
  (window as unknown as Record<string, unknown>).testEvolutionEndpoints = testEvolutionEndpoints
}